const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var MoreCircle24 = function MoreCircle24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "M12 1C9.82441 1 7.69767 1.64514 5.88873 2.85384C4.07979 4.06253 2.66989 5.7805 1.83733 7.79048C1.00477 9.80047 0.786929 12.0122 1.21137 14.146C1.6358 16.2798 2.68345 18.2398 4.22183 19.7782C5.76021 21.3166 7.72022 22.3642 9.85401 22.7886C11.9878 23.2131 14.1995 22.9952 16.2095 22.1627C18.2195 21.3301 19.9375 19.9202 21.1462 18.1113C22.3549 16.3023 23 14.1756 23 12C23.0008 10.5552 22.7168 9.12449 22.1643 7.78955C21.6118 6.45461 20.8015 5.24167 19.7799 4.22007C18.7583 3.19847 17.5454 2.38824 16.2105 1.83572C14.8755 1.2832 13.4448 0.999213 12 1ZM7 13.5C6.70333 13.5 6.41332 13.412 6.16665 13.2472C5.91998 13.0824 5.72772 12.8481 5.61419 12.574C5.50065 12.2999 5.47095 11.9983 5.52883 11.7074C5.5867 11.4164 5.72957 11.1491 5.93934 10.9393C6.14912 10.7296 6.4164 10.5867 6.70737 10.5288C6.99834 10.4709 7.29994 10.5007 7.57403 10.6142C7.84812 10.7277 8.08239 10.92 8.24721 11.1666C8.41203 11.4133 8.5 11.7033 8.5 12C8.5 12.3978 8.34197 12.7794 8.06067 13.0607C7.77936 13.342 7.39783 13.5 7 13.5ZM12 13.5C11.7033 13.5 11.4133 13.412 11.1666 13.2472C10.92 13.0824 10.7277 12.8481 10.6142 12.574C10.5007 12.2999 10.4709 11.9983 10.5288 11.7074C10.5867 11.4164 10.7296 11.1491 10.9393 10.9393C11.1491 10.7296 11.4164 10.5867 11.7074 10.5288C11.9983 10.4709 12.2999 10.5007 12.574 10.6142C12.8481 10.7277 13.0824 10.92 13.2472 11.1666C13.412 11.4133 13.5 11.7033 13.5 12C13.5 12.3978 13.342 12.7794 13.0607 13.0607C12.7794 13.342 12.3978 13.5 12 13.5ZM17 13.5C16.7033 13.5 16.4133 13.412 16.1666 13.2472C15.92 13.0824 15.7277 12.8481 15.6142 12.574C15.5007 12.2999 15.4709 11.9983 15.5288 11.7074C15.5867 11.4164 15.7296 11.1491 15.9393 10.9393C16.1491 10.7296 16.4164 10.5867 16.7074 10.5288C16.9983 10.4709 17.2999 10.5007 17.574 10.6142C17.8481 10.7277 18.0824 10.92 18.2472 11.1666C18.412 11.4133 18.5 11.7033 18.5 12C18.5 12.3978 18.342 12.7794 18.0607 13.0607C17.7794 13.342 17.3978 13.5 17 13.5Z",
      fill: "currentColor",
    })
  );
};
MoreCircle24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: MoreCircle24,
};
export function MoreCircle(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'MoreCircle' icon. Please use one of the available sizes: '24'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
